var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetscode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.061,
    xmlns: "http://www.w3.org/2000/svg",
    height: 80.016,
    id: "screenshot-8ba3758d-ec17-8020-8001-8f49647f2bd6",
    viewBox: "0 0 84.061 80.016",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-8ba3758d-ec17-8020-8001-8f49647f2bd6",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-8ba3758d-ec17-8020-8001-8f4755621728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fills-8ba3758d-ec17-8020-8001-8f4755621728"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M56.247,67L42.247,80L11.247,80C11.247,80,8.323,80.449,4.492,76.618C0.99,73.116,0.247,69,0.247,69L0.247,13C0.247,13,-1.039,8.567,2.259,4.669C6.294,-0.1,11.247,0,11.247,0L37.881,0L49.824,13L14.247,13L14.247,67L56.247,67Z",
    style: {
      fill: "rgb(122, 45, 191)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-8ba3758d-ec17-8020-8001-8f47b6de6b7e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fills-8ba3758d-ec17-8020-8001-8f47b6de6b7e"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M36.051,0C48.051,0,49.316,-0.038,53.051,2C56.649,3.962,59.051,6,59.051,6C59.051,6,83.621,29.991,84.051,31C84.697,32.514,53.051,63,53.051,63L35,63L67.051,31L36.051,0Z",
    style: {
      fill: "rgb(87, 206, 225)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-8ba3758d-ec17-8020-8001-8f48888e2940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fills-8ba3758d-ec17-8020-8001-8f48888e2940"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M67.099,30.904L72.226,35.837C75.596,38.986,75.518,40.597,73.215,43.273L52.617,63.378L34.677,63.378L67.099,30.904Z",
    style: {
      fill: "rgb(254, 215, 0)",
      fillOpacity: 1
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetscode);
export default __webpack_public_path__ + "static/media/letscode.0ba66909d178c7c47dc8f3e95edbe8c0.svg";
export { ForwardRef as ReactComponent };